import type { TranslationResource } from '@/features/iam/api/resources/translations'

export interface PreselectedWorkspaceTranslationsProvider {
  read(): TranslationResource[]
}

export class DefaultPreselectedWorkspaceTranslationsProvider
  implements PreselectedWorkspaceTranslationsProvider
{
  static readonly instance =
    new DefaultPreselectedWorkspaceTranslationsProvider()

  read() {
    return window.__translations
  }
}
